export default {
  featureFlags: {},
  drawer: null,
  color: !localStorage.getItem('thingshiveColor') ? 'warning' : localStorage.getItem('thingshiveColor'),
  UiTheme: localStorage.getItem('thingshiveTheme') === 'dark',
  colorHexLight: undefined,
  colorHexDark: undefined,
  image: !localStorage.getItem('thingshiveImage') ? './img/transparent.png' : localStorage.getItem('thingshiveImage'),
  load: 0,
  loading: false,
  map3DBuild: localStorage.getItem('thingshiveMap3DBuild') === '3D',
  snackbar: {
    model: false,
    message: 'This is a snack, yum',
    color: 'success',
    link: undefined,
  },
  refreshToolbar: 0,
  miniVariant: localStorage.getItem('miniVariant') === 'true',
  baseURL: `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}`,
  docsDomain: 'https://docs.niotix.io',
  docsBaseURL: 'https://docs.niotix.io',
  releaseNotesURL: 'https://docs.niotix.io/changelog/',
  systemStatus: 'https://status.digimondo.io/',
  language: !localStorage.getItem('language') ? 'de' : localStorage.getItem('language'),
  mapStyle: !localStorage.getItem('mapStyle') ? 1 : localStorage.getItem('mapStyle'),
  inpOutlined: true,
  inpFilled: false,
  dtwins: {},
  dtwinStateConfigCopy: null,
  // session-persisted filters for different pages/lists
  // once the page is re-visited, the filters are restored until a full page reload
  // (e.g. orderby, pageidx, filter, search, ...)
  pageFilters: {},
  packageVersion: process.env.PACKAGE_VERSION || '0.0.0',
  announcements: [],
  bannerHeight: 0,
  fireflyUrl:
    process.env.VUE_APP_ENV === 'production-saas' ? 'https://fireflyiot.com' : 'https://stage.fireflyiot.com/',
  refreshGMMinutes: 0,
  rowsPerPage: parseInt(localStorage.getItem('userSelectedItemsPerList')) || 20,
  tablePage: 1,
  openedTreeview: [],
  virtualDeviceListSearch: { items: [], operator: 'AND' },
  useAltFonts: false,
  n2Accounts: {
    lastFetched: null,
    accounts: [],
    selectedIds: [],
  },
  n1Accounts: {
    lastFetched: null,
    accounts: [],
    selectedIds: [],
  },
  feedbackEmail: '',
};
